const actions = {
    SET_DATA: 'countries/SET_DATA',
    GET_DATA: 'countries/GET_DATA',
};

export default actions
